import { createStyles, makeStyles } from "@material-ui/core";

export const useQuotationsDiscountBoxStyle = makeStyles((theme) =>
    createStyles({
        percentButton: {
            marginRight: 8,
        },
    }),
)